import Component from '@bythepixel/component-loader';
import { selectors } from './config';
import utilities from './util';
import KenectObserver from '../shared/KenectObserver';
import Controls from './Controls';

export default class ReviewCarousel extends Component {
  static selector = '[data-comp-review-carousel]';

  scriptEl;
  carouselContainer;
  kenectObserver;
  controlsContainer;
  controls;

  constructor(containerEl) {
    super(containerEl);

    this.scriptEl = utilities.buildScriptEl();
    this.carouselContainer = containerEl.querySelector(
      selectors.carouselContainer,
    );
    this.kenectObserver = new KenectObserver(this.carouselContainer);
    this.controlsContainer = containerEl.querySelector(
      selectors.controlsContainer,
    );
    this.controls = new Controls(this.controlsContainer);

    this.mount();
  }

  mountKenectScript() {
    this.carouselContainer.appendChild(this.scriptEl);
  }

  attachListeners() {
    this.kenectObserver.observe(this.carouselContainer, (currentMutation) => {
      const { addedNodes } = currentMutation;

      if (addedNodes.length === 0) return;

      const hasError = [...addedNodes].some((element) => utilities.isKenectErrorEl(element));

      if (hasError) {
        this.$container.remove();
        this.kenectObserver.disconnect();
      }

      const kenectSlider = document.getElementById(selectors.id.kenectGlide);

      if (kenectSlider && !this.controls.isMounted) {
        this.controls.mount(kenectSlider);
        this.kenectObserver.disconnect();
      }
    });
  }

  mount() {
    this.attachListeners();
    this.mountKenectScript();
  }
}
